import { useColorMode } from '@vueuse/core'

export function useTheme() {
  const mode = useColorMode({
    attribute: 'class',
    modes: { light: '', dark: 'dark' }
  })

  return { mode }
}
